import React from "react";
import { Button, Tooltip } from "antd";
import { DataTable } from "./DataTable";
import { DataTable1 } from "./DataTable1";
import { YhBox } from "@/components/YhBox";
import { useJxcModel } from "../jxcModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { IDescription, DescriptionColorEnum } from "@/components/YhBox/Types";
import { globalPrompt } from "@/components/message";
import { disableExportMsg } from "@/utils/exportFile";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";

export const DataBox = () => {
    const { exportJxc, jxcOrGoodsDetail, setJxcOrGoodsDetail, descTotal, selectedRowKeys } = useJxcModel();
    const goodsDetail = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        setJxcOrGoodsDetail("goodsDetail")
    }
    const action = <>

        <YhAuth resCode={ResourceAuthEnum.VRM2_STT_JXC_STATISTICSREPORT}>
            <Button
                className={`mr-5 ${jxcOrGoodsDetail === "jxcRecord" ? "tab-buts-active" : ""}`}
                type="primary"
                shape="round"
                onClick={() => setJxcOrGoodsDetail("jxcRecord")}
            >进销存统计报表</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.VRM2_STT_JXC_GOODLEDGER}>
            <Button
                className={`mr-5 ${jxcOrGoodsDetail === "goodsDetail" ? "tab-buts-active" : ""}`}
                type="primary"
                shape="round"
                onClick={() => goodsDetail()}
            >商品明细账</Button>
            {/* <Button
            className={`mr-5 ${jxcOrGoodsDetail === "goodsDetail" ? "tab-buts-active" : ""}`}
            type="primary"
            shape="round"
            onClick={() => setJxcOrGoodsDetail("goodsDetail")}
        >商品明细账</Button> */}
            {/* <YhAuth resCode={ResourceAuthEnum.ST_STAFF_EX}> */}
            {/* <Tooltip placement="topLeft" title={disableExportMsg}> */}
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.VRM2_STT_JXC_EX}>
            <Button
                disabled={false}
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => exportJxc()}
            >导出</Button>
        </YhAuth>
        {/* </Tooltip> */}

        {/* </YhAuth> */}
    </>;
    const desc: IDescription[] = [
        {
            label: "初始数量",
            value: descTotal.startNum,
            color: DescriptionColorEnum.red
        },
        {
            label: "初始金额",
            value: descTotal.startAmount,
            color: DescriptionColorEnum.red
        },
        {
            label: "期末数量",
            value: descTotal.inventoryNum ?? 0,
            color: DescriptionColorEnum.red
        },
        {
            label: "期末金额",
            value: descTotal.lastestPriceAmount ?? 0,
            color: DescriptionColorEnum.red
        },
        {
            label: "入库数",
            value: descTotal.warehousingInNum,
            color: DescriptionColorEnum.red
        },
        {
            label: "入库金额",
            value: descTotal.warehousingInAmount,
            color: DescriptionColorEnum.red
        },
        {
            label: "出库数",
            value: descTotal.warehouseOutNum,
            color: DescriptionColorEnum.red
        },
        {
            label: "出库金额",
            value: descTotal.warehouseOutAmount,
            color: DescriptionColorEnum.red
        },
    ]
    return (
        // <YhBox title="进销存统计报表" action={action} descriptions={desc} style={{height:'calc(100vh - 200px)'}}>
        <YhBox action={action} style={{ height: 'calc(100vh - 180px)' }}>
            {jxcOrGoodsDetail === "jxcRecord" ? <DataTable /> : <DataTable1 />}
        </YhBox>
    )
}